'use strict';
import { addEvent } from '../addEvent/addEvent';
import { smoothScrollbarInit } from '../smoothScrollbar/smoothScrollbar';

export const mobileMenu = class {
  bodyClassName = 'mobile-menu';
  bodyMobileMenuShowClassName = 'mobile-menu-show';
  mobileMenuButtonClassName = 'mobile-menu-button';
  mobileMenuContainerClassName = 'mobile-menu-container';
  mobileMenuScrollContainerClassName = 'mobil-menu';

  nav = false;
  body = false;
  menuList = false;
  mobileMenuContainer = false;
  mobileMenuButton = false;
  mobileMenuButtonContainer = false;
  mobileMenuInsertContainer = false;
  mobileShow = false;
  smoothScroll = false;

  constructor() {
    let nav = document.getElementsByClassName('page-header__menu')[0];
    this.nav = nav;
    this.menuList = nav.querySelector('ul').cloneNode(true);
    this.body = document.getElementsByTagName('body')[0];
    this.mobileMenuButtonContainer = document.getElementsByClassName(
      'header__center-content'
    )[0];
    this.mobileMenuInsertContainer =
      document.getElementsByClassName('header')[0];
    this.test();
    addEvent(window, 'resize', () => {
      this.test();
    });
    return this;
  }

  test = () => {
    const { enabled, disabled } = this;

    const breakPoint = 1300;
    const widthWin = window.innerWidth;

    if (breakPoint > widthWin) {
      enabled();
    } else {
      disabled();
    }
  };

  enabled = () => {
    const { body, bodyClassName, _createMenuButton, _cereateMenuContainer } =
      this;
    body.classList.add(bodyClassName);
    _createMenuButton();
    _cereateMenuContainer();

    if (
      !document.body.classList.contains('mobile') &&
      !document.body.classList.contains('macos')
    )
      this.smoothScroll = smoothScrollbarInit(
        { damping: 0.1 },
        '.' + this.mobileMenuScrollContainerClassName,
        { enableModal: false }
      );
  };

  disabled = () => {
    const { body, bodyClassName, _removeMenuButton, _remveMenuContainer } =
      this;
    body.classList.remove(bodyClassName);
    _removeMenuButton();
    _remveMenuContainer();

    if (this.smoothScroll) this.smoothScroll?.destroy();
  };

  _cereateMenuContainer = () => {
    const {
      nav,
      body,
      mobileMenuContainerClassName,
      mobileMenuButtonContainer,
      mobileMenuInsertContainer,
      mobileMenuScrollContainerClassName,
      menuList,
    } = this;

    if (this.mobileMenuContainer) return;

    let mobileMenuContainer = document.createElement('div');
    mobileMenuContainer.classList.add(mobileMenuContainerClassName);

    let mobileMenuScrollContainer = document.createElement('div');
    mobileMenuScrollContainer.classList.add(mobileMenuScrollContainerClassName);

    mobileMenuScrollContainer.appendChild(menuList);
    mobileMenuContainer.appendChild(mobileMenuScrollContainer);

    this.mobileMenuContainer =
      mobileMenuInsertContainer.appendChild(mobileMenuContainer);
  };

  _remveMenuContainer = () => {
    if (!this.mobileMenuContainer) return;

    this.mobileMenuContainer.remove();
    this.mobileMenuContainer = false;
  };

  _createMenuButton = () => {
    const {
      body,
      nav,
      mobileMenuButtonContainer,
      mobileMenuButtonClassName,
      bodyMobileMenuShowClassName,
    } = this;
    if (this.mobileMenuButton) return;

    let mobileButton = document.createElement('button');
    mobileButton.classList.add(mobileMenuButtonClassName);

    let span = document.createElement('span');
    mobileButton.appendChild(span);
    span = document.createElement('span');
    mobileButton.appendChild(span);
    span = document.createElement('span');
    mobileButton.appendChild(span);
    span = document.createElement('span');
    mobileButton.appendChild(span);
    span = document.createElement('span');
    mobileButton.appendChild(span);
    span = document.createElement('span');
    mobileButton.appendChild(span);

    this.mobileMenuButton = mobileMenuButtonContainer.appendChild(mobileButton);

    addEvent(this.mobileMenuButton, 'click', e => {
      e.preventDefault();
      if (this.mobileShow) {
        body.classList.remove(bodyMobileMenuShowClassName);
        this.mobileShow = false;
        window.smoothScroll?.setModalOpen(false);
      } else {
        body.classList.add(bodyMobileMenuShowClassName);
        this.mobileShow = true;
        window.smoothScroll?.setModalOpen(true);
      }
    });

    addEvent(document, 'keyup', e => {
      if (e.keyCode == 27 && this.mobileShow) {
        body.classList.remove(bodyMobileMenuShowClassName);
        this.mobileShow = false;
        window.smoothScroll?.setModalOpen(false);
      }
    });
  };

  _removeMenuButton = () => {
    if (!this.mobileMenuButton) return;

    this.mobileMenuButton.remove();
    this.mobileMenuButton = false;
  };
};
